import { get as getConstants } from '@lumapps/constants';

import { AppId, URL_PREFIX_BY_APP_ID } from '../constants';

const constants = getConstants();

/**
 * Gets the application ID from the URL by checking for the presence of the app prefix.
 * @param url
 * @returns string
 */
export const getAppIdFromUrl = (url: string): AppId => {
    const prefixes = Object.entries(URL_PREFIX_BY_APP_ID);
    const sortedPrefixes = prefixes.sort((a, b) => b[1].localeCompare(a[1]));
    const isPrefixInUrl = sortedPrefixes.find((prefix) => url.startsWith(`/${prefix[1]}`));

    return isPrefixInUrl ? (isPrefixInUrl[0] as AppId) : constants.applicationId;
};
